import { AsyncPipe, NgFor } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { ConfigService } from 'src/app/shared/services/config.service';
import { TransportJobReportStoreService } from '../transport-job-report-store.service';
import { take } from 'rxjs/operators';
import { sub } from 'date-fns';

@Component({
  selector: 'app-controls-dialog',
  templateUrl: './controls-dialog.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    NgFor,
    MatInput,
    MatButton,
    AsyncPipe,
    MatDatepickerModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule
  ]
})
export class ControlsDialogComponent implements OnInit {
  form = new FormGroup({
    from: new FormControl<Date>(null),
    fromTime: new FormControl<string>(null),
    to: new FormControl<Date>(null),
    toTime: new FormControl<string>(null),
    assignedTo: new FormControl<number>(null)
  });

  store = inject(TransportJobReportStoreService);
  users$ = inject(ConfigService).allUsers;
  dialogRef = inject(MatDialogRef<ControlsDialogComponent>);

  ngOnInit(): void {
    this.store.filters$.pipe(take(1)).subscribe((filters) => {
      this.form.patchValue({
        from: filters.from
          ? new Date(filters.from)
          : sub(new Date(), { days: 28 }),
        to: filters.to ? new Date(filters.to) : new Date(),
        fromTime: filters.from?.split('T')?.[1] ?? '00:00',
        toTime: filters.to?.split('T')?.[1] ?? '23:59',
        assignedTo: filters.assignedTo
      });
    });
  }

  generateReport() {
    const from =
      this.form.value.from.toISOString().split('T')[0] +
      ' ' +
      (this.form.value.fromTime ?? '00:00');
    const to =
      this.form.value.to.toISOString().split('T')[0] +
      ' ' +
      (this.form.value.toTime ?? '23:59');
    const filters = {
      from: from,
      to: to,
      assignedTo: this.form.value.assignedTo
    };
    this.store.generateReport(filters);
    this.dialogRef.close();
  }
}
